import type { OutreachView } from '../../types/outreach'

// The glance: the five numbers a partner reads before they read a name. Every one of them is a count of
// rows on the queue below, so pressing it filters rather than opening a different truth.
export function Glance({ view, reason, onPick }: { view: OutreachView; reason: string; onPick: (kind: string) => void }) {
  const total = view.items.length
  const bandCounts = view.bands.map((b) => ({ band: b, count: view.items.filter((i) => i.band?.key === b.key).length }))

  return (
    <section className="glance outreach-glance">
      <div className="glance-stats">
        <button
          type="button"
          className={`glance-stat as-button ${reason === 'all' ? 'on' : ''}`}
          onClick={() => onPick('all')}
        >
          <strong>{total}</strong>
          <span>{total === 1 ? 'person to contact today' : 'people to contact today'}</span>
        </button>
        {view.counts.map((c) => (
          <button
            key={c.kind}
            type="button"
            className={`glance-stat as-button ${reason === c.kind ? 'on' : ''} ${c.count === 0 ? 'empty' : ''}`}
            onClick={() => onPick(reason === c.kind ? 'all' : c.kind)}
            disabled={c.count === 0}
          >
            <strong>{c.count}</strong>
            <span>{c.label.toLowerCase()}</span>
          </button>
        ))}
      </div>

      <div className="glance-busiest outreach-bands">
        <p className="kicker">Your bands, and how often you keep them</p>
        <ul>
          {bandCounts.map(({ band, count }) => (
            <li key={band.key} title={band.basis}>
              <span>{band.label} · {band.cadence}</span>
              <span className="muted">{count} up</span>
            </li>
          ))}
        </ul>
        <p className="muted small">
          A band is where a person sits by how strong the tie is. Someone you have never written to carries no band
          and no cadence — an imported name is not a relationship.
        </p>
      </div>
    </section>
  )
}
